import type { ResponsiveSpacingType } from '@crehana/ui';
import type { ColValue } from '@crehana/ui/dist/GridV2/types';

export const COMMON_COLS: Readonly<
  Record<keyof ResponsiveSpacingType, ColValue>
> = {
  xs: 12,
  sm: 4,
  md: 3,
  lg: 4,
};
